import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { ILabRequestsInboxModel } from "@/Portfolio/Models/UI/IRequestsInboxModel";
import { PortfolioStore } from "@/Portfolio/Stores/PortfolioStore";

class MyRequestsSettingsContainerHandler extends BaseOperationHandler {
    constructor() {
        super();

        this.RegisterOperation(LocalOperations.Portfolio.MyRequests_SearchSettings_ShowOptionsButtonClick, this.DisplayMyRequestsSettings);
        this.RegisterOperation(LocalOperations.Portfolio.MyRequests_SearchSettings_CancelClick, this.OnCancelClick);
        this.RegisterOperation(LocalOperations.Portfolio.MyRequests_SearchSettings_OkClick, this.OnOkClick);
        this.RegisterOperation(LocalOperations.Portfolio.MyRequests_SearchSettings_ColumnOrderingPopup_Open, this.ShowColumnOrderingPopup);
        this.RegisterOperation(LocalOperations.Portfolio.MyRequests_SearchSettings_ColumnOrderingPopup_Close, this.CloseColumnOrderingPopup);

        this.RegisterOperation(LocalOperations.Misc.MyleApp_Container_Click, this.CloseSearchFilterPopup, false);
    }

    private ShowColumnOrderingPopup(request: LocalEvent, store: PortfolioStore): void {
        store.RequestsInboxModel = store.RequestsInboxModel
            .set("ColumnOrderingPopupOpen", true)
            .set("ShowMyRequestsDisplaySettings", false);
    }

    private CloseColumnOrderingPopup(request: LocalEvent, store: PortfolioStore): void {
        store.RequestsInboxModel = store.RequestsInboxModel
            .set("ColumnOrderingPopupOpen", false)
            .set("ShowMyRequestsDisplaySettings", false);
    }

    private DisplayMyRequestsSettings(request: LocalEvent, store: PortfolioStore): void {
        const isOpen = store.RequestsInboxModel.get("ShowMyRequestsDisplaySettings");
        store.RequestsInboxModel = store.RequestsInboxModel.set("ShowMyRequestsDisplaySettings", !isOpen);
    }

    private OnCancelClick(request: LocalEvent, store: PortfolioStore): void {
        store.RequestsInboxModel = store.RequestsInboxModel.set("ShowMyRequestsDisplaySettings", false);
    }

    private OnOkClick(request: LocalEvent, store: PortfolioStore): void {
        store.RequestsInboxModel = (request.Get<ILabRequestsInboxModel>("updatedModel") ?? store.RequestsInboxModel)
            .set("ShowMyRequestsDisplaySettings", false);

        store.PortfolioActions.LoadMyRequests(store.RequestsInboxModel);
    }

    private CloseSearchFilterPopup(request: LocalEvent, store: PortfolioStore): void {
        if (store.RequestsInboxModel.get("ShowMyRequestsDisplaySettings") === true) {
            this.OnOkClick(request, store);
            store.EmitChangeToListeners();
        }
    }
}

export { MyRequestsSettingsContainerHandler };
